import { createContext, useContext, JSX } from "solid-js";
import {
  usePaymentLoader,
  UsePaymentLoaderProps,
  UsePaymentLoaderReturn,
} from "../hooks/use_payment_loader";

const PaymentLoaderContext = createContext<UsePaymentLoaderReturn>();

export function usePaymentLoaderContext() {
  const context = useContext(PaymentLoaderContext);
  if (!context) {
    throw new Error(
      "usePaymentLoaderContext must be used within PaymentLoaderProvider"
    );
  }
  return context;
}

export interface PaymentLoaderProviderProps extends UsePaymentLoaderProps {
  children: JSX.Element;
}

export function PaymentLoaderProvider(
  props: PaymentLoaderProviderProps
): JSX.Element {
  const paymentLoader = usePaymentLoader({
    orderId: props.orderId,
    amount: props.amount,
    onClose: props.onClose,
    reInit: props.reInit,
    onPaymentComplete: props.onPaymentComplete,
    onPaymentFailed: props.onPaymentFailed,
  });

  return (
    <PaymentLoaderContext.Provider value={paymentLoader}>
      {props.children}
    </PaymentLoaderContext.Provider>
  );
}
